/**
 * @enum
 * @readonly
 */
const DATE_RANGES = {
  ALL_TIME: 0,
  THIS_YEAR: 1,
  THIS_MONTH: 2,
  REALTIME: 3,
  LAST_MONTH: 4,
};

export default DATE_RANGES;
